package com.mps.asc_app.config

import kotlinx.browser.window

actual val isDebugBuild: Boolean
    get() = runCatching {
        val host = window.location.hostname.lowercase()
        host == "localhost" || host == "127.0.0.1"
    }.getOrDefault(false)

